import { NoteEditComponent } from './note-edit/note-edit.component';
import { Note } from '../generated/interfaces';
import { Routes, Resolve } from '@angular/router';
import { NoteCreateComponent } from './note-create/note-create.component';
import { idUrlMatcher } from 'mrugames-seed';

export function createNoteChildrenRoutes(noteResolver: new (...args: any[]) => Resolve<Note>): Routes {
    return [
        {
            path: 'new',
            component: NoteCreateComponent,
            pathMatch: 'full'
        },
        {
            component: NoteEditComponent,
            resolve: {
                note: noteResolver,
            },
            path: ':id'
        },
    ];
}